import React, { useContext, useEffect } from 'react';
import IdentityProviders from './IdentityProviders';
import { ErrorContext } from 'ErrorContext';
import { BaseIntegrationProps } from 'helpers/integration/BaseIntegrationProps';

export interface IIdentityProvidersRenderer {
    integrationProps: BaseIntegrationProps;
}

const IdentityProvidersRenderer = ({
    integrationProps
}: IIdentityProvidersRenderer): React.ReactElement => {

    const { setError } = useContext(ErrorContext);

    const error = integrationProps.getMissingPropertyError();

    useEffect(() => {
        if (error !== null) {
            setError(error);
            setError(error);
        }
    }, [error, setError]);

    return (
        <IdentityProviders />
    );
};
export default IdentityProvidersRenderer;
